import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import React from 'react'
import { ApiTableColumn } from '@e3dc-react/shell/Elements/ApiView/ApiView'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AdditionalDevice } from '../models/additional-devices.model'

interface AdditionalDevicesProps {
  installationId: string | undefined
}

/**
 * List of additional devices inside the installation.
 */
const AdditionalDevices: React.FC<AdditionalDevicesProps> = ({ installationId }) => {
  const { t } = useCustomTranslation()

  const fetchProps = {
    url: `installations/${installationId}/device-list`,
    endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
  }

  const columns: ApiTableColumn<AdditionalDevice>[] = [
    {
      name: 'serialno',
      label: t('common.serialnumber'),
      value: item => item.deviceSerialno,
      sortable: false,
    },
    {
      name: 'type',
      label: t('common.type'),
      value: item => item.type,
      sortable: false,
    },
    {
      name: 'model',
      label: t('common.model'),
      value: item => item.model,
      sortable: false,
    },
  ]

  return (
    <ApiView<AdditionalDevice>
      fetchProps={fetchProps}
      tableColumns={columns}
      hasColoredTableColumns
      bodyElevation={0}
      footerElevation={0}
      headerElevation={0}
      listElevation={0}
      initialTablePageLimit={5}
      listProps={{
        primary: (device: AdditionalDevice) => device.serialno,
        dataQa: (device: AdditionalDevice) => `additional-device-${device.serialno}`,
        secondary: (device: AdditionalDevice) => device.type,
      }}
    />
  )
}

export default AdditionalDevices
